/**
 * 文字列制限Utility
 * @param str
 * @param length
 */
export const shapingString = (str: string, length: number) => {
    const matchStr = str.substring(0, length);
    const overStr = str.substring(10).length > 0 ? "..." : "";
    const result = matchStr + overStr;
    return result;
};
